import { render, staticRenderFns } from "./Yddstock.vue?vue&type=template&id=40792977&scoped=true&"
import script from "./Yddstock.vue?vue&type=script&lang=js&"
export * from "./Yddstock.vue?vue&type=script&lang=js&"
import style0 from "./Yddstock.vue?vue&type=style&index=0&id=40792977&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40792977",
  null
  
)

export default component.exports